<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path d="M6.10059 0.75C9.05585 0.75 11.4521 3.14621 11.4521 6.10156C11.4519 9.0567 9.0557 11.4521 6.10059 11.4521C3.14566 11.4519 0.750244 9.05656 0.75 6.10156C0.75 3.14635 3.14551 0.750228 6.10059 0.75Z" stroke="black" stroke-width="1.5"/>
    <path d="M10.0503 9.93262L14.1176 14" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconSearchFilter'
}
</script>
